// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-\\[1px\\] {
  inset: 1px;
}
.inset-\\[3px\\] {
  inset: 3px;
}
.inset-\\[6px\\] {
  inset: 6px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-top-\\[1\\%\\] {
  top: -1%;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-\\[5px\\] {
  bottom: 5px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[13\\%\\] {
  left: 13%;
}
.left-\\[16\\%\\] {
  left: 16%;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[13\\%\\] {
  right: 13%;
}
.right-\\[16\\%\\] {
  right: 16%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-\\[7\\%\\] {
  top: 7%;
}
.top-\\[74\\%\\] {
  top: 74%;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.-z-20 {
  z-index: -20;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[3\\] {
  z-index: 3;
}
.z-\\[4\\] {
  z-index: 4;
}
.z-\\[999\\] {
  z-index: 999;
}
.m-0 {
  margin: 0px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0 {
  margin-left: 0px;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-10 {
  height: 2.5rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[118px\\] {
  height: 118px;
}
.h-\\[120\\%\\] {
  height: 120%;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[15\\%\\] {
  height: 15%;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[210px\\] {
  height: 210px;
}
.h-\\[36\\%\\] {
  height: 36%;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[78vh\\] {
  height: 78vh;
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[48vh\\] {
  max-height: 48vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[92\\%\\] {
  width: 92%;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[110rem\\] {
  max-width: 110rem;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[16rem\\] {
  max-width: 16rem;
}
.max-w-\\[22rem\\] {
  max-width: 22rem;
}
.max-w-\\[25rem\\] {
  max-width: 25rem;
}
.max-w-\\[75vw\\] {
  max-width: 75vw;
}
.max-w-\\[90rem\\] {
  max-width: 90rem;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[42\\%\\] {
  --tw-translate-y: -42%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.06\\] {
  --tw-scale-x: 1.06;
  --tw-scale-y: 1.06;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.15\\] {
  --tw-scale-x: 1.15;
  --tw-scale-y: 1.15;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.2\\] {
  --tw-scale-x: 1.2;
  --tw-scale-y: 1.2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\] {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulseScale {

  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }

  50% {
    transform: scale(1.01);
    opacity: 0.35;
  }
}
.animate-pulseScale {
  animation: pulseScale 4s ease-in-out infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-14 {
  row-gap: 3.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[22px\\] {
  border-radius: 22px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[26px\\] {
  border-radius: 26px;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-\\[\\#8A5D00\\] {
  --tw-border-opacity: 1;
  border-color: rgb(138 93 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F6C453\\]\\/60 {
  border-color: rgb(246 196 83 / 0.6);
}
.border-\\[\\#FFD487\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 212 135 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFD879\\]\\/70 {
  border-color: rgb(255 216 121 / 0.7);
}
.border-\\[\\#FFE28A\\]\\/70 {
  border-color: rgb(255 226 138 / 0.7);
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/35 {
  background-color: rgb(0 0 0 / 0.35);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-gray-200\\/30 {
  background-color: rgb(229 231 235 / 0.3);
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#000000_0\\%\\2c \\#0F0A00_55\\%\\2c \\#201600_100\\%\\)\\] {
  background-image: linear-gradient(90deg,#000000 0%,#0F0A00 55%,#201600 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#050505_0\\%\\2c \\#2F2000_48\\%\\2c \\#A96F00_78\\%\\2c \\#D08E00_100\\%\\)\\] {
  background-image: linear-gradient(90deg,#050505 0%,#2F2000 48%,#A96F00 78%,#D08E00 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#201600_0\\%\\2c \\#0F0A00_45\\%\\2c \\#000000_100\\%\\)\\] {
  background-image: linear-gradient(90deg,#201600 0%,#0F0A00 45%,#000000 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#D08E00_0\\%\\2c \\#A96F00_22\\%\\2c \\#2F2000_52\\%\\2c \\#050505_100\\%\\)\\] {
  background-image: linear-gradient(90deg,#D08E00 0%,#A96F00 22%,#2F2000 52%,#050505 100%);
}
.bg-\\[radial-gradient\\(circle_at_center\\2c rgba\\(255\\2c 193\\2c 61\\2c 0\\.18\\)\\2c transparent_68\\%\\)\\] {
  background-image: radial-gradient(circle at center,rgba(255,193,61,0.18),transparent 68%);
}
.bg-\\[radial-gradient\\(ellipse_80\\%_80\\%_at_center\\2c \\#D08E00_8\\%\\2c \\#6A4800_32\\%\\2c \\#000000_50\\%\\)\\] {
  background-image: radial-gradient(ellipse 80% 80% at center,#D08E00 8%,#6A4800 32%,#000000 50%);
}
.bg-\\[radial-gradient\\(ellipse_85\\%_115\\%_at_50\\%_50\\%\\2c \\#D08E00_18\\%\\2c \\#6A4800_32\\%\\2c \\#000000_55\\%\\)\\] {
  background-image: radial-gradient(ellipse 85% 115% at 50% 50%,#D08E00 18%,#6A4800 32%,#000000 55%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-\\[\\#000000\\] {
  --tw-gradient-from: #000000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#201600\\] {
  --tw-gradient-from: #201600 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(32 22 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D08E00\\] {
  --tw-gradient-from: #D08E00 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(208 142 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D08E00\\]\\/70 {
  --tw-gradient-from: rgb(208 142 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(208 142 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D08E00\\]\\/80 {
  --tw-gradient-from: rgb(208 142 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(208 142 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black {
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/20 {
  --tw-gradient-from: rgb(0 0 0 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/75 {
  --tw-gradient-from: rgb(0 0 0 / 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin1 {
  --tw-gradient-from: #D69900 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(214 153 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin2 {
  --tw-gradient-from: #FFED62 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 98 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin3\\/80 {
  --tw-gradient-from: rgb(144 98 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(144 98 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin4 {
  --tw-gradient-from: #392700 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(57 39 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin5 {
  --tw-gradient-from: #6A4800 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(106 72 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-prin5\\/20 {
  --tw-gradient-from: rgb(106 72 0 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(106 72 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/10 {
  --tw-gradient-from: rgb(255 255 255 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/15 {
  --tw-gradient-from: rgb(255 255 255 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/45 {
  --tw-gradient-from: rgb(255 255 255 / 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#9B6800\\]\\/70 {
  --tw-gradient-to: rgb(155 104 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(155 104 0 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #000 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/15 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.15) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-gold {
  --tw-gradient-to: rgb(208 142 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #D08E00 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-prin5 {
  --tw-gradient-to: rgb(106 72 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6A4800 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/10 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#000000\\] {
  --tw-gradient-to: #000000 var(--tw-gradient-to-position);
}
.to-\\[\\#201600\\] {
  --tw-gradient-to: #201600 var(--tw-gradient-to-position);
}
.to-\\[\\#3D2900\\]\\/85 {
  --tw-gradient-to: rgb(61 41 0 / 0.85) var(--tw-gradient-to-position);
}
.to-\\[\\#6A4800\\] {
  --tw-gradient-to: #6A4800 var(--tw-gradient-to-position);
}
.to-\\[\\#6A4800\\]\\/70 {
  --tw-gradient-to: rgb(106 72 0 / 0.7) var(--tw-gradient-to-position);
}
.to-black\\/10 {
  --tw-gradient-to: rgb(0 0 0 / 0.1) var(--tw-gradient-to-position);
}
.to-gold\\/50 {
  --tw-gradient-to: rgb(208 142 0 / 0.5) var(--tw-gradient-to-position);
}
.to-prin1 {
  --tw-gradient-to: #D69900 var(--tw-gradient-to-position);
}
.to-prin2 {
  --tw-gradient-to: #FFED62 var(--tw-gradient-to-position);
}
.to-prin3 {
  --tw-gradient-to: #906200 var(--tw-gradient-to-position);
}
.to-prin4 {
  --tw-gradient-to: #392700 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.object-right {
  object-position: right;
}
.p-0 {
  padding: 0px;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[38px\\] {
  font-size: 38px;
}
.text-\\[clamp\\(2\\.4rem\\2c 9vw\\2c 4\\.8rem\\)\\] {
  font-size: clamp(2.4rem,9vw,4.8rem);
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[0\\.92\\] {
  line-height: 0.92;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.06em\\] {
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[4px\\] {
  letter-spacing: 4px;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#4C2E00\\] {
  --tw-text-opacity: 1;
  color: rgb(76 46 0 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-300\\/80 {
  color: rgb(209 213 219 / 0.8);
}
.text-gray-300\\/95 {
  color: rgb(209 213 219 / 0.95);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/65 {
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_34px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 14px 34px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 14px 34px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 24px 70px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 24px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.20\\)\\] {
  --tw-shadow: 0 8px 24px rgba(0,0,0,0.20);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_rgba\\(116\\2c 68\\2c 0\\2c 0\\.55\\)\\] {
  --tw-shadow: inset 0 0 0 1px rgba(116,68,0,0.55);
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[1px\\] {
  --tw-blur: blur(1px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[3px\\] {
  --tw-blur: blur(3px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-110 {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-90 {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_1px_1px_rgba\\(255\\2c 242\\2c 174\\2c 0\\.75\\)\\] {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgba(255,242,174,0.75));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.\\[text-shadow\\:0_0_6px_\\#fff\\2c 0_0_12px_\\#fff\\2c 0_0_18px_\\#ff4da6\\2c 0_0_26px_\\#D69900\\2c 0_0_36px_\\#FFED62\\] {
  text-shadow: 0 0 6px #fff,0 0 12px #fff,0 0 18px #ff4da6,0 0 26px #D69900,0 0 36px #FFED62;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.hide-scrollbar {
  scrollbar-width: none; /* Para Firefox */
  -ms-overflow-style: none; /* Para Internet Explorer y Edge */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Para Chrome, Safari y Opera */
}

.stroke-white {
  -webkit-text-stroke: 1.5px white;
  text-stroke: 1.5px white; /* Para navegadores modernos */
}

.stroke-yellow {
  -webkit-text-stroke: 1.5px #ffed62;
  text-stroke: 1.5px #ffed62;
}

/* En tu archivo CSS */
.texto-borde-degradado {
  color: transparent;
  -webkit-text-stroke: 2px;
  -webkit-text-stroke-color: white;
  background: linear-gradient(to right, #ffd700, #ff8c00);
  -webkit-background-clip: text;
  background-clip: text;
}

@keyframes brillo-recorrido {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* =========================================
   GOLDEN CURSOR
   ========================================= */

.cursor-hidden,
.cursor-hidden * {
  cursor: none !important;
}

/* Cursor principal / halo */
.golden-cursor {
  position: fixed;
  left: 0;
  top: 0;

  width: var(--r, 240px);
  height: var(--r, 240px);

  pointer-events: none;
  z-index: 9999;

  translate:
    calc(var(--cx, -1000px) - 50%)
    calc(var(--cy, -1000px) - 50%);

  border-radius: 9999px;

  /*
   * Halo principal.
   * El centro queda ligeramente iluminado
   * y desaparece progresivamente.
   */
  background: radial-gradient(
    circle at center,
    rgba(255, 237, 98, 0.21) 0%,
    rgba(255, 215, 0, 0.1) 28%,
    rgba(255, 237, 98, 0.035) 52%,
    rgba(255, 237, 98, 0) 72%
  );

  opacity: 1;

  transform: scale(1);

  will-change: transform, translate;

  transition:
    transform 420ms cubic-bezier(0.16, 1, 0.3, 1),
    opacity 250ms ease,
    filter 350ms ease;
}

/* =========================================
   CÍRCULO CENTRAL
   ========================================= */

.golden-cursor::after {
  content: "";

  position: absolute;

  left: 50%;
  top: 50%;

  width: var(--dot, 16px);
  height: var(--dot, 16px);

  transform: translate(-50%, -50%) scale(1);

  border-radius: 9999px;

  /*
   * En estado normal queda bastante oscuro
   * y solamente conserva un tono dorado.
   */
  background: radial-gradient(
    rgba(164, 135, 0, 1) 0%,
    rgba(55, 48, 19, 0.78) 100%
  );

  border: 1px solid rgba(255, 255, 255, 0.55);

  opacity: 0.48;

  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    inset 0 -1px 2px rgba(0, 0, 0, 0.2),
    0 3px 10px rgba(0, 0, 0, 0.22);

  transition:
    transform 320ms cubic-bezier(0.16, 1, 0.3, 1),
    background 320ms ease,
    border-color 320ms ease,
    box-shadow 320ms ease,
    opacity 320ms ease;
}

/* =========================================
   ELEMENTO CLICKEABLE
   ========================================= */

/*
 * Cuando encuentra:
 *
 * - button
 * - link
 * - input
 * - role="button"
 * - cursor-pointer
 * - etc.
 *
 * el halo se contrae.
 */
.golden-cursor.is-interactive {
  transform: scale(0.56);

  filter: saturate(1.15);
}

/*
 * El punto central recupera su tamaño visual.
 *
 * Como el padre está en scale(.56), escalamos
 * el círculo interior hacia arriba para que
 * no quede demasiado pequeño.
 */
.golden-cursor.is-interactive::after {
  transform:
    translate(-50%, -50%)
    scale(1.8);

  opacity: 0.95;

  /*
   * Ahora sí aparece el amarillo,
   * pero sin convertirse en un amarillo plano.
   */
  background: radial-gradient(
    rgba(255, 255, 225, 0.9) 10%,
    rgba(255, 237, 98, 0.40) 70%,
    rgba(105, 82, 0, 0.1) 100%
  );

  border-color: rgb(255, 254, 247);

  box-shadow:
    inset 0 1px 1px rgba(255, 255, 255, 0.75),
    inset 0 -2px 4px rgba(100, 72, 0, 0.18),
    0 2px 10px rgba(0, 0, 0, 0.2),
    0 0 14px rgba(255, 221, 45, 0.25);
}

/* =========================================
   CLICK
   ========================================= */

.golden-cursor.is-clicking {
  transform: scale(0.82);
}

/*
 * Si además estamos sobre algo clickeable,
 * respetamos el tamaño reducido del halo.
 */
.golden-cursor.is-interactive.is-clicking {
  transform: scale(0.49);
}

/* Click normal */
.golden-cursor.is-clicking::after {
  transform:
    translate(-50%, -50%)
    scale(0.9);

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    0 2px 7px rgba(0, 0, 0, 0.2),
    0 0 0 5px rgba(255, 237, 98, 0.1);
}

/*
 * Click mientras estamos sobre botón/link.
 * Mantenemos compensado el tamaño por
 * el scale del padre.
 */
.golden-cursor.is-interactive.is-clicking::after {
  transform:
    translate(-50%, -50%)
    scale(1.65);

  background: radial-gradient(
    #fffce1 60%,
    #d7a900 100%,
  );

  box-shadow:
    inset 0 1px 1px rgba(255, 255, 255, 0.8),
    0 2px 7px rgba(0, 0, 0, 0.22),
    0 0 0 4px rgba(255, 237, 98, 0.11);
}

/* =========================================
   OCULTAR CURSOR PERSONALIZADO
   ========================================= */

.golden-cursor {
  transition:
    transform 320ms cubic-bezier(0.16, 1, 0.3, 1),
    opacity 220ms ease,
    filter 350ms ease;
}

.golden-cursor.is-hidden {
  opacity: 0;
  transform: scale(0.35);
}

.hover\\:scale-\\[1\\.015\\]:hover {
  --tw-scale-x: 1.015;
  --tw-scale-y: 1.015;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-white\\/40:hover {
  border-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-yellow-600\\/50:hover {
  background-color: rgb(202 138 4 / 0.5);
}

.hover\\:text-\\[\\#6A4800\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(106 72 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-gold:hover {
  --tw-text-opacity: 1;
  color: rgb(208 142 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:shadow-\\[0_0_12px_rgba\\(208\\2c 142\\2c 0\\2c 0\\.45\\)\\2c 0_0_28px_rgba\\(208\\2c 142\\2c 0\\2c 0\\.25\\)\\2c 0_0_55px_rgba\\(127\\2c 86\\2c 0\\2c 0\\.15\\)\\]:hover {
  --tw-shadow: 0 0 12px rgba(208,142,0,0.45),0 0 28px rgba(208,142,0,0.25),0 0 55px rgba(127,86,0,0.15);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color), 0 0 28px var(--tw-shadow-color), 0 0 55px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_12px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]:hover {
  --tw-shadow: 0 12px 30px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 12px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.group\\/btn:hover .group-hover\\/btn\\:-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/btn:hover .group-hover\\/btn\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/btn:hover .group-hover\\/btn\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:text-\\[\\#FFD36A\\] {
  --tw-text-opacity: 1;
  color: rgb(255 211 106 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/btn:hover .group-hover\\/btn\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-85 {
  opacity: 0.85;
}

.group:hover .group-hover\\:shadow-\\[0_14px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 14px 40px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 14px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:drop-shadow-\\[0_0_6px_rgba\\(255\\2c 193\\2c 61\\2c 0\\.7\\)\\] {
  --tw-drop-shadow: drop-shadow(0 0 6px rgba(255,193,61,0.7));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group:hover .group-hover\\:drop-shadow-\\[0_0_8px_rgba\\(255\\2c 193\\2c 61\\2c 0\\.35\\)\\] {
  --tw-drop-shadow: drop-shadow(0 0 8px rgba(255,193,61,0.35));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group:hover .group-hover\\:backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

@media (min-width: 640px) {

  .sm\\:left-5 {
    left: 1.25rem;
  }

  .sm\\:mb-12 {
    margin-bottom: 3rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mr-8 {
    margin-right: 2rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-\\[138px\\] {
    height: 138px;
  }

  .sm\\:h-\\[180px\\] {
    height: 180px;
  }

  .sm\\:h-\\[240px\\] {
    height: 240px;
  }

  .sm\\:h-\\[85vh\\] {
    height: 85vh;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:w-28 {
    width: 7rem;
  }

  .sm\\:w-\\[88\\%\\] {
    width: 88%;
  }

  .sm\\:w-\\[90px\\] {
    width: 90px;
  }

  .sm\\:max-w-\\[20\\.5rem\\] {
    max-width: 20.5rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:scale-\\[1\\.03\\] {
    --tw-scale-x: 1.03;
    --tw-scale-y: 1.03;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-y-16 {
    row-gap: 4rem;
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pt-4 {
    padding-top: 1rem;
  }

  .sm\\:pt-5 {
    padding-top: 1.25rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-\\[46px\\] {
    font-size: 46px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:tracking-\\[0\\.10em\\] {
    letter-spacing: 0.10em;
  }
}

@media (min-width: 768px) {

  .md\\:bottom-10 {
    bottom: 2.5rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:ml-24 {
    margin-left: 6rem;
  }

  .md\\:ml-52 {
    margin-left: 13rem;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-28 {
    margin-top: 7rem;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:h-56 {
    height: 14rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-\\[300px\\] {
    height: 300px;
  }

  .md\\:w-32 {
    width: 8rem;
  }

  .md\\:w-\\[22vw\\] {
    width: 22vw;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:max-w-2xl {
    max-width: 42rem;
  }

  .md\\:max-w-lg {
    max-width: 32rem;
  }

  .md\\:max-w-xs {
    max-width: 20rem;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .md\\:gap-12 {
    gap: 3rem;
  }

  .md\\:gap-14 {
    gap: 3.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .md\\:rounded-\\[30px\\] {
    border-radius: 30px;
  }

  .md\\:rounded-\\[50px\\] {
    border-radius: 50px;
  }

  .md\\:bg-black\\/30 {
    background-color: rgb(0 0 0 / 0.3);
  }

  .md\\:bg-\\[radial-gradient\\(ellipse_40\\%_110\\%_at_50\\%_50\\%\\2c \\#D08E00_18\\%\\2c \\#6A4800_32\\%\\2c \\#000000_50\\%\\)\\] {
    background-image: radial-gradient(ellipse 40% 110% at 50% 50%,#D08E00 18%,#6A4800 32%,#000000 50%);
  }

  .md\\:bg-\\[radial-gradient\\(ellipse_60\\%_100\\%_at_center\\2c \\#D08E00_8\\%\\2c \\#6A4800_32\\%\\2c \\#000000_50\\%\\)\\] {
    background-image: radial-gradient(ellipse 60% 100% at center,#D08E00 8%,#6A4800 32%,#000000 50%);
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .md\\:pt-16 {
    padding-top: 4rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .md\\:tracking-\\[12px\\] {
    letter-spacing: 12px;
  }

  .md\\:tracking-\\[5px\\] {
    letter-spacing: 5px;
  }

  .md\\:opacity-70 {
    opacity: 0.7;
  }

  .md\\:blur-lg {
    --tw-blur: blur(16px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
}

@media (min-width: 1024px) {

  .lg\\:left-6 {
    left: 1.5rem;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:mt-12 {
    margin-top: 3rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:h-96 {
    height: 24rem;
  }

  .lg\\:h-\\[100vh\\] {
    height: 100vh;
  }

  .lg\\:h-\\[152px\\] {
    height: 152px;
  }

  .lg\\:h-\\[200px\\] {
    height: 200px;
  }

  .lg\\:h-\\[260px\\] {
    height: 260px;
  }

  .lg\\:h-\\[400px\\] {
    height: 400px;
  }

  .lg\\:min-h-screen {
    min-height: 100vh;
  }

  .lg\\:w-\\[100px\\] {
    width: 100px;
  }

  .lg\\:w-\\[22vw\\] {
    width: 22vw;
  }

  .lg\\:w-\\[86\\%\\] {
    width: 86%;
  }

  .lg\\:max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .lg\\:max-w-xl {
    max-width: 36rem;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:rounded-\\[50px\\] {
    border-radius: 50px;
  }

  .lg\\:p-12 {
    padding: 3rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .lg\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .lg\\:text-\\[52px\\] {
    font-size: 52px;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .lg\\:blur-md {
    --tw-blur: blur(12px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
}

@media (min-width: 1280px) {

  .xl\\:ml-4 {
    margin-left: 1rem;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,sBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB,EAAE,iBAAiB;EACxC,wBAAwB,EAAE,kCAAkC;AAC9D;AACA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,gCAAgC;EAChC,wBAAwB,EAAE,8BAA8B;AAC1D;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,uDAAuD;EACvD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;8CAE8C;;AAE9C;;EAEE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,OAAO;EACP,MAAM;;EAEN,sBAAsB;EACtB,uBAAuB;;EAEvB,oBAAoB;EACpB,aAAa;;EAEb;;kCAEgC;;EAEhC,qBAAqB;;EAErB;;;;IAIE;EACF;;;;;;GAMC;;EAED,UAAU;;EAEV,mBAAmB;;EAEnB,iCAAiC;;EAEjC;;;qBAGmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,WAAW;;EAEX,kBAAkB;;EAElB,SAAS;EACT,QAAQ;;EAER,uBAAuB;EACvB,wBAAwB;;EAExB,yCAAyC;;EAEzC,qBAAqB;;EAErB;;;IAGE;EACF;;;GAGC;;EAED,2CAA2C;;EAE3C,aAAa;;EAEb,0BAA0B;EAC1B,kCAAkC;;EAElC;;;kCAGgC;;EAEhC;;;;;sBAKoB;AACtB;;AAEA;;8CAE8C;;AAE9C;;;;;;;;;;;EAWE;AACF;EACE,sBAAsB;;EAEtB,sBAAsB;AACxB;;AAEA;;;;;;EAME;AACF;EACE;;cAEY;;EAEZ,aAAa;;EAEb;;;IAGE;EACF;;;;GAIC;;EAED,gCAAgC;;EAEhC;;;;qCAImC;AACrC;;AAEA;;8CAE8C;;AAE9C;EACE,sBAAsB;AACxB;;AAEA;;;EAGE;AACF;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE;;cAEY;;EAEZ;;;qCAGmC;AACrC;;AAEA;;;;EAIE;AACF;EACE;;eAEa;;EAEb;;;GAGC;;EAED;;;sCAGoC;AACtC;;AAEA;;8CAE8C;;AAE9C;EACE;;;qBAGmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AA7QA;EAAA,mBA6QC;EA7QD,mBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,sBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,qGA6QC;EA7QD,sHA6QC;EA7QD;AA6QC;;AA7QD;EAAA,yCA6QC;EA7QD,uDA6QC;EA7QD;AA6QC;;AA7QD;EAAA,8BA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,2BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,yBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,yBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,iBA6QC;EA7QD,iBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,yCA6QC;EA7QD,uDA6QC;EA7QD;AA6QC;;AA7QD;EAAA,2DA6QC;EA7QD;AA6QC;;AA7QD;EAAA,4DA6QC;EA7QD;AA6QC;;AA7QD;EAAA,8BA6QC;EA7QD;AA6QC;;AA7QD;;EAAA;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,8DA6QC;IA7QD;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,4DA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,qBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;AAAA;;AA7QD;;EAAA;IAAA;EA6QC;;EA7QD;IAAA,gBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,2DA6QC;IA7QD;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,+DA6QC;IA7QD;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,4DA6QC;IA7QD;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,8DA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,qBA6QC;IA7QD;EA6QC;AAAA;;AA7QD;;EAAA;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,gBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,uBA6QC;IA7QD,uDA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,qBA6QC;IA7QD;EA6QC;AAAA;;AA7QD;;EAAA;IAAA;EA6QC;;EA7QD;IAAA;EA6QC;;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.hide-scrollbar {\n  scrollbar-width: none; /* Para Firefox */\n  -ms-overflow-style: none; /* Para Internet Explorer y Edge */\n}\n.hide-scrollbar::-webkit-scrollbar {\n  display: none; /* Para Chrome, Safari y Opera */\n}\n\n.stroke-white {\n  -webkit-text-stroke: 1.5px white;\n  text-stroke: 1.5px white; /* Para navegadores modernos */\n}\n\n.stroke-yellow {\n  -webkit-text-stroke: 1.5px #ffed62;\n  text-stroke: 1.5px #ffed62;\n}\n\n/* En tu archivo CSS */\n.texto-borde-degradado {\n  color: transparent;\n  -webkit-text-stroke: 2px;\n  -webkit-text-stroke-color: white;\n  background: linear-gradient(to right, #ffd700, #ff8c00);\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n@keyframes brillo-recorrido {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* =========================================\n   GOLDEN CURSOR\n   ========================================= */\n\n.cursor-hidden,\n.cursor-hidden * {\n  cursor: none !important;\n}\n\n/* Cursor principal / halo */\n.golden-cursor {\n  position: fixed;\n  left: 0;\n  top: 0;\n\n  width: var(--r, 240px);\n  height: var(--r, 240px);\n\n  pointer-events: none;\n  z-index: 9999;\n\n  translate:\n    calc(var(--cx, -1000px) - 50%)\n    calc(var(--cy, -1000px) - 50%);\n\n  border-radius: 9999px;\n\n  /*\n   * Halo principal.\n   * El centro queda ligeramente iluminado\n   * y desaparece progresivamente.\n   */\n  background: radial-gradient(\n    circle at center,\n    rgba(255, 237, 98, 0.21) 0%,\n    rgba(255, 215, 0, 0.1) 28%,\n    rgba(255, 237, 98, 0.035) 52%,\n    rgba(255, 237, 98, 0) 72%\n  );\n\n  opacity: 1;\n\n  transform: scale(1);\n\n  will-change: transform, translate;\n\n  transition:\n    transform 420ms cubic-bezier(0.16, 1, 0.3, 1),\n    opacity 250ms ease,\n    filter 350ms ease;\n}\n\n/* =========================================\n   CÍRCULO CENTRAL\n   ========================================= */\n\n.golden-cursor::after {\n  content: \"\";\n\n  position: absolute;\n\n  left: 50%;\n  top: 50%;\n\n  width: var(--dot, 16px);\n  height: var(--dot, 16px);\n\n  transform: translate(-50%, -50%) scale(1);\n\n  border-radius: 9999px;\n\n  /*\n   * En estado normal queda bastante oscuro\n   * y solamente conserva un tono dorado.\n   */\n  background: radial-gradient(\n    rgba(164, 135, 0, 1) 0%,\n    rgba(55, 48, 19, 0.78) 100%\n  );\n\n  border: 1px solid rgba(255, 255, 255, 0.55);\n\n  opacity: 0.48;\n\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.45),\n    inset 0 -1px 2px rgba(0, 0, 0, 0.2),\n    0 3px 10px rgba(0, 0, 0, 0.22);\n\n  transition:\n    transform 320ms cubic-bezier(0.16, 1, 0.3, 1),\n    background 320ms ease,\n    border-color 320ms ease,\n    box-shadow 320ms ease,\n    opacity 320ms ease;\n}\n\n/* =========================================\n   ELEMENTO CLICKEABLE\n   ========================================= */\n\n/*\n * Cuando encuentra:\n *\n * - button\n * - link\n * - input\n * - role=\"button\"\n * - cursor-pointer\n * - etc.\n *\n * el halo se contrae.\n */\n.golden-cursor.is-interactive {\n  transform: scale(0.56);\n\n  filter: saturate(1.15);\n}\n\n/*\n * El punto central recupera su tamaño visual.\n *\n * Como el padre está en scale(.56), escalamos\n * el círculo interior hacia arriba para que\n * no quede demasiado pequeño.\n */\n.golden-cursor.is-interactive::after {\n  transform:\n    translate(-50%, -50%)\n    scale(1.8);\n\n  opacity: 0.95;\n\n  /*\n   * Ahora sí aparece el amarillo,\n   * pero sin convertirse en un amarillo plano.\n   */\n  background: radial-gradient(\n    rgba(255, 255, 225, 0.9) 10%,\n    rgba(255, 237, 98, 0.40) 70%,\n    rgba(105, 82, 0, 0.1) 100%\n  );\n\n  border-color: rgb(255, 254, 247);\n\n  box-shadow:\n    inset 0 1px 1px rgba(255, 255, 255, 0.75),\n    inset 0 -2px 4px rgba(100, 72, 0, 0.18),\n    0 2px 10px rgba(0, 0, 0, 0.2),\n    0 0 14px rgba(255, 221, 45, 0.25);\n}\n\n/* =========================================\n   CLICK\n   ========================================= */\n\n.golden-cursor.is-clicking {\n  transform: scale(0.82);\n}\n\n/*\n * Si además estamos sobre algo clickeable,\n * respetamos el tamaño reducido del halo.\n */\n.golden-cursor.is-interactive.is-clicking {\n  transform: scale(0.49);\n}\n\n/* Click normal */\n.golden-cursor.is-clicking::after {\n  transform:\n    translate(-50%, -50%)\n    scale(0.9);\n\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.55),\n    0 2px 7px rgba(0, 0, 0, 0.2),\n    0 0 0 5px rgba(255, 237, 98, 0.1);\n}\n\n/*\n * Click mientras estamos sobre botón/link.\n * Mantenemos compensado el tamaño por\n * el scale del padre.\n */\n.golden-cursor.is-interactive.is-clicking::after {\n  transform:\n    translate(-50%, -50%)\n    scale(1.65);\n\n  background: radial-gradient(\n    #fffce1 60%,\n    #d7a900 100%,\n  );\n\n  box-shadow:\n    inset 0 1px 1px rgba(255, 255, 255, 0.8),\n    0 2px 7px rgba(0, 0, 0, 0.22),\n    0 0 0 4px rgba(255, 237, 98, 0.11);\n}\n\n/* =========================================\n   OCULTAR CURSOR PERSONALIZADO\n   ========================================= */\n\n.golden-cursor {\n  transition:\n    transform 320ms cubic-bezier(0.16, 1, 0.3, 1),\n    opacity 220ms ease,\n    filter 350ms ease;\n}\n\n.golden-cursor.is-hidden {\n  opacity: 0;\n  transform: scale(0.35);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
